export { default as ProductImageGallery } from './ProductImageGallery';
export * as Styled from './ProductImageGallery.styles';
export * from './ProductImageGallery.types';
